import { http, HttpResponse } from 'msw'

import type { DistributionChannelId } from '@/@types/distribution-channel-id'

interface MockCreateDistributionPathParams {
  alphaId: string
}

interface MockCreateDistributionBody {
  distributionChannelId: DistributionChannelId
  companyId: number
  data: {
    nationalContent?: boolean
    internationalContent?: boolean
    pms?: {
      pmsId: string
      code: string
    }[]
    code?: string
    login?: string
    password?: string
  }
}

export const mockCreateDistribution = http.post<
  MockCreateDistributionPathParams,
  MockCreateDistributionBody
>('/my-business/api/agency/v1/*/:alphaId/distributions', () => {
  return HttpResponse.json(null, { status: 201 })
})
